
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/content-migrations/jst/subviews/ChooseMigrationFile';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<label class=\"control-label\" for=\"migrationFileUpload\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.choose_migration_file")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.choose_migration_file.migration_text", "Source", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.choose_migration_file.migration_text", "Source", options)))
    + "</strong></label>\n<div class=\"controls controlMargin\">\n  <input id=\"migrationFileUpload\" name=\"file\" type=\"file\" accept=\".zip,.imscc,.mbz,.xml\">\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  